import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { AbstractPerformanceRequirementProof } from './abstract-performance-requirement-proof.model';

export class WslpPerformanceRequirementProof extends AbstractPerformanceRequirementProof {
	url: string;
	@Transform(dateTransformer)
	date: Date;
}
